import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './produtoForm';
import imagemSoLogo from '../assets/images/sologo.png';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';

import {
	setModoTela, initForm, salvar, excluir, getLista, getListaTipo
} from './produtoActions';

class Produto extends Component {

	state = {
		linhaSelecionada: null,
		idTipoSelecionado: null
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaTipo();
    }

    render() {

		if (this.state.idTipoSelecionado == null && this.props.listaTipo.length > 0) {
			this.setState({
				...this.state,
				idTipoSelecionado: this.props.listaTipo[0].id
			});
		}

        return (
            <div>

				{this.props.aguardando ? (
					<div class='modal fade show' id='modal-overlay' style={{ display: 'block', paddingRight: 15 }} aria-modal='true' role='dialog'>
						<div class='modal-dialog'>
							<div class='overlay'>
								<div style={{ marginLeft: '50%', marginRight: '50%' }}>
									<img src={imagemSoLogo} style={{ height: 40, width: 40, marginBottom: -76, marginLeft: 8 }} />
								</div>
								<i class='fas fa-4x fa-spinner fa-spin' style={{ marginLeft: '50%', marginRight: '50%' }}></i>
							</div>
						</div>
					</div>
				) : null}

                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({});
								}} />
						</Grid>
						<Grid cols='6 6 4 2'>
							<ExcelFile
								filename={'Produtos'}
								element={
									<Button
										text='Exportar'
										type={'primary'}
										icon={'fa fa-plus'} />
								}>
								{this.props.listaTipo.map(tipo => (
									<ExcelSheet data={this.props.lista.filter(item => (item.produto_tipos || []).includes(tipo.id))} name={tipo.valor}>
										<ExcelColumn label='Nome comercial' value='nome' />
										<ExcelColumn label='Composição' value='composicao' />
										<ExcelColumn label='Classe' value='classe' />
										<ExcelColumn label='Grupo Químico' value='grupo_quimico' />
									</ExcelSheet>
								))}
							</ExcelFile>
						</Grid>
					</Row>
				</ContentCardHeader>

				<ul class='nav nav-tabs' id='custom-tabs-four-tab' role='tablist'>
					{this.props.listaTipo.map(item => (
						<li key={item.id} class='nav-item'>
							<a class={`nav-link ${item.id == this.state.idTipoSelecionado ? 'active' : ''}`}
								id='custom-tabs-four-home-tab'
								data-toggle='pill' href='#custom-tabs-four-home' role='tab'
								aria-controls='custom-tabs-four-home'
								aria-selected='true'
								onClick={() => {
									this.setState({
										...this.state,
										idTipoSelecionado: item.id
									});
								}}>{item.valor}</a>
						</li>
					))}
				</ul>
				<ContentCardBody>
					<Table responsive>
						<THead>
							<Tr>
								<Th>Nome comercial</Th>
								<Th>Composição</Th>
								<Th>Classe</Th>
								<Th>Grupo Químico</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.lista.filter(item => (item.produto_tipos || []).includes(this.state.idTipoSelecionado)).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{item.nome}</Td>
									<Td>{item.composicao}</Td>
									<Td>{item.classe}</Td>
									<Td>{item.grupo_quimico}</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.produto.modoTela,
	lista: state.produto.lista,
	listaTipo: state.produto.listaTipo,
	aguardando: state.produto.aguardando
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, salvar, excluir, getLista, getListaTipo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Produto);
